module.exports = __webpack_public_path__ + "b83e6e0d67d7da41c010e14502a3f269.svg";